import PRPAuthConflictModal from './PRPAuthConflictModalContainer';

export default PRPAuthConflictModal;
